import React, { useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPinIcon, NavigationIcon, TrainIcon, BusIcon, TramFrontIcon, ShoppingBagIcon, UtensilsIcon, TheaterIcon, BuildingIcon, StoreIcon, CoffeeIcon } from 'lucide-react';
export function Location() {
  const [activeTab, setActiveTab] = useState('harta');
  const tabContentVariants = {
    hidden: {
      opacity: 0,
      y: 10
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.3
      }
    },
    exit: {
      opacity: 0,
      y: -10,
      transition: {
        duration: 0.2
      }
    }
  };
  const tabs = [{
    id: 'harta',
    label: 'Hartă & Poziție'
  }, {
    id: 'transport',
    label: 'Transport Public'
  }, {
    id: 'puncte',
    label: 'Puncte de Interes'
  }];
  const transportData = [{
    icon: TrainIcon,
    name: 'Metrou Piața Unirii',
    distance: '850 m',
    time: '7-8 min',
    lines: 'M1, M2, M3',
    color: '#ef4444'
  }, {
    icon: TrainIcon,
    name: 'Metrou Tineretului',
    distance: '600 m',
    time: '5-6 min',
    lines: 'M1, M3',
    color: '#8b5cf6'
  }, {
    icon: BusIcon,
    name: 'Stație Autobuz',
    distance: '200 m',
    time: '2-3 min',
    lines: '123, 385, 601',
    color: '#3b82f6'
  }, {
    icon: TramFrontIcon,
    name: 'Stație Tramvai',
    distance: '300 m',
    time: '3-4 min',
    lines: '7, 11, 19',
    color: '#10b981'
  }];
  const poiData = [{
    icon: ShoppingBagIcon,
    name: 'Unirea Shopping Center',
    distance: '900 m',
    type: 'Centru comercial',
    color: '#8b5cf6'
  }, {
    icon: UtensilsIcon,
    name: 'Restaurante & Cafenele',
    distance: '100-500 m',
    type: 'Zona gastronomică',
    color: '#f59e0b'
  }, {
    icon: TheaterIcon,
    name: 'Teatrul Național',
    distance: '1.2 km',
    type: 'Cultură & Artă',
    color: '#ec4899'
  }, {
    icon: BuildingIcon,
    name: 'Instituții Publice',
    distance: '500-1000 m',
    type: 'Primărie, Prefectură',
    color: '#357beb'
  }, {
    icon: StoreIcon,
    name: 'Magazine & Servicii',
    distance: '50-300 m',
    type: 'Comerț local',
    color: '#06b6d4'
  }, {
    icon: CoffeeIcon,
    name: 'Cafenele Premium',
    distance: '100-400 m',
    type: 'Starbucks, 5 to go',
    color: '#84cc16'
  }];
  const locationInfo = [{
    icon: MapPinIcon,
    title: 'Adresă',
    content: ['Strada Cuza Vodă nr. 50–52', 'Sector 4, București']
  }, {
    icon: NavigationIcon,
    title: 'Distanțe Cheie',
    content: ['Piața Unirii: 850 m', 'Palatul Parlamentului: 1,9 km', 'Piața Universitate: ~10 min']
  }];
  return <section className="py-20 px-6 md:px-12 lg:px-16 bg-gray-50" data-id="element-285">
      <div className="max-w-7xl mx-auto" data-id="element-286">
        <h2 className="text-3xl md:text-4xl font-bold text-[#121c53] text-center mb-6" data-id="element-287">
          Locație Strategică
        </h2>
        <p className="text-gray-700 text-center mb-12 max-w-3xl mx-auto text-lg" data-id="element-288">
          Poziționare centrală, conectată la instituții, zone comerciale și
          transport public. 7–8 minute de mers pe jos până la Piața Unirii și 10
          minute de Universitate.
        </p>
        {/* Tabbed Interface */}
        <div className="bg-white rounded-xl shadow-lg overflow-hidden" data-id="element-289">
          {/* Tab Headers */}
          <div className="flex border-b border-gray-100" data-id="element-290">
            {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className="flex-1 py-4 px-4 text-sm md:text-base font-medium transition-all relative hover:scale-105" style={{
            color: activeTab === tab.id ? '#357beb' : '#6b7280'
          }} data-id="element-291">
                {tab.label}
                {activeTab === tab.id && <motion.div layoutId="activeTabLocation" className="absolute bottom-0 left-0 right-0 h-0.5 bg-[#357beb]" transition={{
              type: 'spring',
              stiffness: 500,
              damping: 30
            }} data-id="element-292" />}
              </button>)}
          </div>
          {/* Tab Content */}
          <div className="p-6 md:p-8" data-id="element-293">
            <AnimatePresence mode="wait" data-id="element-294">
              <motion.div key={activeTab} variants={tabContentVariants} initial="hidden" animate="visible" exit="exit" data-id="element-295">
                {/* Map */}
                <div className="relative aspect-[16/9] md:aspect-[21/9] rounded-xl overflow-hidden shadow-lg mb-8" data-id="element-296">
                  <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2849.0127891234567!2d26.105689315743!3d44.42007997910234!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b1ff4f1234abcd%3A0x1234567890abcdef!2sStrada%20Cuza%20Vod%C4%83%2052%2C%20Bucure%C8%99ti!5e0!3m2!1sen!2sro!4v1234567890123" width="100%" height="100%" style={{
                  border: 0
                }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Locație Cuza Vodă 52" data-id="element-297" />
                </div>
                {/* Dynamic Content Cards */}
                {activeTab === 'harta' && <div className="grid md:grid-cols-2 gap-6" data-id="element-298">
                    {locationInfo.map((item, index) => <motion.div key={index} className="bg-gray-50 p-6 rounded-xl" initial={{
                  opacity: 0,
                  y: 20
                }} animate={{
                  opacity: 1,
                  y: 0
                }} transition={{
                  delay: index * 0.1
                }} data-id="element-299">
                        <div className="flex items-start gap-4" data-id="element-300">
                          <div className="p-3 bg-[#357beb]/10 rounded-lg" data-id="element-301">
                            <item.icon className="w-6 h-6 text-[#357beb]" data-id="element-302" />
                          </div>
                          <div className="flex-1" data-id="element-303">
                            <h3 className="font-semibold text-[#121c53] text-lg mb-3" data-id="element-304">
                              {item.title}
                            </h3>
                            {item.content.map((line, i) => <p key={i} className="text-gray-700 mb-1" data-id="element-305">
                                {line}
                              </p>)}
                          </div>
                        </div>
                      </motion.div>)}
                    <motion.div className="md:col-span-2 bg-gradient-to-br from-[#357beb] to-[#2868d9] p-6 rounded-xl text-white" initial={{
                  opacity: 0,
                  y: 20
                }} animate={{
                  opacity: 1,
                  y: 0
                }} transition={{
                  delay: 0.2
                }} data-id="element-306">
                      <h3 className="font-semibold text-lg mb-2" data-id="element-307">
                        Zona Premium
                      </h3>
                      <p className="text-gray-100" data-id="element-308">
                        Centrul istoric al Bucureștiului, cu acces rapid la
                        instituții, transport public și zone comerciale de top.
                      </p>
                    </motion.div>
                  </div>}
                {activeTab === 'transport' && <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-309">
                    {transportData.map((item, index) => <motion.div key={index} className="bg-gray-50 p-6 rounded-xl hover:shadow-md transition-shadow" initial={{
                  opacity: 0,
                  y: 20
                }} animate={{
                  opacity: 1,
                  y: 0
                }} transition={{
                  delay: index * 0.1
                }} data-id="element-310">
                        <div className="flex flex-col gap-4" data-id="element-311">
                          <div className="flex items-center gap-3" data-id="element-312">
                            <div className="p-3 rounded-lg" style={{
                        backgroundColor: `${item.color}20`
                      }} data-id="element-313">
                              <item.icon className="w-6 h-6" style={{
                          color: item.color
                        }} data-id="element-314" />
                            </div>
                            <h3 className="font-semibold text-[#121c53]" data-id="element-315">
                              {item.name}
                            </h3>
                          </div>
                          <div className="space-y-2" data-id="element-316">
                            <div className="flex justify-between items-center" data-id="element-317">
                              <span className="text-sm text-gray-600" data-id="element-318">
                                Distanță
                              </span>
                              <span className="font-semibold text-[#357beb]" data-id="element-319">
                                {item.distance}
                              </span>
                            </div>
                            <div className="flex justify-between items-center" data-id="element-320">
                              <span className="text-sm text-gray-600" data-id="element-321">
                                Timp
                              </span>
                              <span className="font-semibold text-[#357beb]" data-id="element-322">
                                {item.time}
                              </span>
                            </div>
                            <div className="flex justify-between items-center" data-id="element-323">
                              <span className="text-sm text-gray-600" data-id="element-324">
                                Linii
                              </span>
                              <span className="font-semibold text-[#121c53]" data-id="element-325">
                                {item.lines}
                              </span>
                            </div>
                          </div>
                        </div>
                      </motion.div>)}
                  </div>}
                {activeTab === 'puncte' && <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-326">
                    {poiData.map((item, index) => <motion.div key={index} className="bg-gray-50 p-6 rounded-xl hover:shadow-md transition-shadow" initial={{
                  opacity: 0,
                  y: 20
                }} animate={{
                  opacity: 1,
                  y: 0
                }} transition={{
                  delay: index * 0.1
                }} data-id="element-327">
                        <div className="flex flex-col gap-3" data-id="element-328">
                          <div className="p-3 rounded-lg w-fit" style={{
                      backgroundColor: `${item.color}20`
                    }} data-id="element-329">
                            <item.icon className="w-6 h-6" style={{
                        color: item.color
                      }} data-id="element-330" />
                          </div>
                          <div data-id="element-331">
                            <h3 className="font-semibold text-[#121c53] mb-1" data-id="element-332">
                              {item.name}
                            </h3>
                            <p className="text-sm text-gray-600 mb-2" data-id="element-333">
                              {item.type}
                            </p>
                            <p className="text-sm font-semibold text-[#357beb]" data-id="element-334">
                              {item.distance}
                            </p>
                          </div>
                        </div>
                      </motion.div>)}
                  </div>}
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>;
}